import { useSuspenseQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useInboxNames() {
  return useSuspenseQuery({
    ...apiClient.listInboxNamesInboxNamesGetOptions(),
  })
}
